module.exports = __webpack_public_path__ + "static/media/Orinocco90.d73ec759.jpg";